import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth.service';
import { ApiResponse } from '@classes/api-response';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private base_url = environment.base_url + '/report';

  constructor(public http: HttpClient, private auth: AuthService) { }

  getTaxReport(startDate: Date, endDate: Date): Observable<any> {
    const store = this.auth.getStore();
    return this.http
      .put(`${this.base_url}/tax/${store}`, { startDate, endDate })
      .pipe(map((res: ApiResponse<any[]>) => res));
  }

  getDutyReport(startDate: Date, endDate: Date): Observable<any> {
    const store = this.auth.getStore();
    return this.http
      .put(`${this.base_url}/duty/${store}`, { startDate, endDate })
      .pipe(map((res: ApiResponse<any>) => res));
  }

  getCustomersReport(): Observable<any> {
    const store = this.auth.getStore();
    return this.http
      .put(`${this.base_url}/customers/${store}`, {})
      .pipe(map((res: ApiResponse<any[]>) => res));
  }

  getCustomerEmailsReport(): Observable<any> {
    const store = this.auth.getStore();
    return this.http
      .put(`${this.base_url}/customer-emails/${store}`, {})
      .pipe(map((res: ApiResponse<any[]>) => res));
  }

  getCustomerExpiredRxReport(): Observable<any> {
    const store = this.auth.getStore();
    return this.http
      .put(`${this.base_url}/customer-expired-rx/${store}`, {})
      .pipe(map((res: ApiResponse<any[]>) => res));
  }
}
